import React, { Component } from 'react';
/** PERSONAL */
import Stem, { getDom } from '../../../NormalStem';
import Footer from '../../../Footer';
import { reverseParseTextView } from '../../../select/createRender';
import { STAGE_TAG } from '../../../../../../utils/questionManageType';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQload();
    }

    componentDidUpdate() {
        this.MQload();
    }

    MQload = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            // 然而, 我们这里并不是可编辑的
            MQ.StaticMath(item);
        });
    };

    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({ visible: val });
    };

    render() {
        const { visible, data } = this.state;
        const { stem, item_list, answer } = data;
        const { stage } = this.props;

        return (
            <div className="question-wrapper" ref={el => this.viewer = el}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text step-tag"><span style={{ color: '#ffffff' }}>{STAGE_TAG[stage]}</span></p>
                    </div>
                    <div className="question-stem">
                        <Stem stem={stem} />
                        <div className="question-options">
                            {
                                item_list.map((val, key) =>
                                    <div className="question-option" key={key}>
                                        <span className="question-option-code">{val.code}、</span>
                                        <span className="question-option-item">
                                            {
                                                val.item.map((v, i) => getDom(v, i))
                                            }
                                        </span>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="question-footer">
                    {
                        visible ?
                            <div className="footer-hide relative">
                                <div className="inline-block"><span>正确答案：</span></div>
                                <div className="inline-block">
                                    {
                                        answer.map((item, i) =>
                                            <span className="answer" key={i}>{item.choice}</span>
                                        )
                                    }
                                </div>
                            </div> : null
                    }
                    <div className="footer-show">
                        <Footer {...this.props}>
                            <span
                                className="question-btn"
                                onClick={(e) => this.toggleAnswer(!visible, e)}>
                                {!visible ? '显示答案' : '隐藏答案'}
                            </span>
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/select/view.js